import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {

  @Input() allowDecimal = false;

  private invalidChars = ['-', '+', 'e'];

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // Block invalid characters
    if (this.invalidChars.includes(event.key)) {
      event.preventDefault();
      return;
    }

    // Allow Ctrl/Cmd shortcuts
    if ((event.ctrlKey || event.metaKey) && ['a','c','v','x'].includes(event.key.toLowerCase())) {
      return;
    }

    // Allow navigation and editing keys
    if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 
         'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
         'Home', 'End'].includes(event.key)) {
      return;
    }

    // Allow decimal if enabled
    if (this.allowDecimal && event.key === '.') {
      return;
    }

    // Block if not a number
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    const pastedData = event.clipboardData?.getData('text') || '';
    let sanitized = pastedData.replace(/[^0-9.]/g, '');

    // Allow only one decimal point if decimals allowed
    if (this.allowDecimal) {
      const parts = sanitized.split('.');
      if (parts.length > 2) {
        sanitized = parts[0] + '.' + parts.slice(1).join('');
      }
    } else {
      sanitized = sanitized.replace(/\./g, '');
    }

    const target = event.target as HTMLInputElement;
    const start = target.selectionStart || 0;
    const end = target.selectionEnd || 0;
    const value = target.value;

    const newValue =
      value.substring(0, start) +
      sanitized +
      value.substring(end);

    target.value = newValue;

    target.dispatchEvent(new Event('input'));
  }
}
